import React, { useState } from "react"
import { Box, Button, Typography } from "@mui/material"
import { useSelector } from "react-redux"

import { RootState } from "../../store/store"
import { ContentContainer, StyledDivider } from "./components/styles"
import {
  DetailValue,
  DetailLabel,
  DetailContainer,
} from "../../components/OperationHistoryDetails/styled"
import { usePaymentCheck } from "../../api/hooks/usePaymentCheck"
import LoadingOverlay from "../../components/LoadingOverlay"
import { useCreatePayment } from "../../api/hooks/useCreatePayment"
import { usePaymentStatus } from "../../api/hooks/usePaymentStatus"

export const PaymentConfirmation = () => {
  const { amount, selectedBank } = useSelector((state: RootState) => state.payment)
  const { data } = usePaymentCheck(amount ?? 0)
  const [combinedPaymentId, setCombinedPaymentId] = useState<string | null>(null)
  const { mutate: createPayment, isPending: isCreating } = useCreatePayment()
  const { isLoading } = usePaymentStatus(combinedPaymentId)

  const handleContinue = () => {
    if (selectedBank?.bankId) {
      createPayment({ bankId: selectedBank.bankId, amount, exchangeRate: data?.exchangeRate }, {
        onSuccess: (result) => {
          setCombinedPaymentId(result.combinedPaymentId)
        },
      })
    }
  }

  if (isCreating || isLoading) {
    return (
      <LoadingOverlay
        disableOpacity
        title="Подтвердите операцию"
        text={
          <>
            Подтвердите списание в приложении <br />
            выбранного банка и дождитесь <br />
            выполнения платежа
          </>
        }
      />
    )
  }

  return (
    <Box sx={ContentContainer}>
      <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
        <Typography variant="h1">{amount || 0} ₽</Typography>
        <Typography variant="h4" color="text.secondary" mt={4}>
          Сумма пополнения
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap={2} width="100%">
        <StyledDivider sx={{ width: "100%" }} />
        <DetailContainer>
          <DetailLabel>Сумма зачисления</DetailLabel>
          <DetailValue>{data?.amountInCurrency} {data?.recipient?.accountCurrency}</DetailValue>
        </DetailContainer>
        <DetailContainer>
          <DetailLabel>Получатель</DetailLabel>
          <DetailValue>{data?.recipient?.displayName}</DetailValue>
        </DetailContainer>
        <DetailContainer>
          <DetailLabel>Банк получателя</DetailLabel>
          <DetailValue>МБанк</DetailValue>
        </DetailContainer>
        <DetailContainer>
          <DetailLabel>Счет зачисления</DetailLabel>
          <DetailValue>{data?.recipient?.accountNumber}</DetailValue>
        </DetailContainer>
        <DetailContainer>
          <DetailLabel>Курс конвертации</DetailLabel>
          <DetailValue>1 ₽ - {data?.exchangeRate} {data?.recipient?.accountCurrency}</DetailValue>
        </DetailContainer>
      </Box>
      <Box mt="auto" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Button variant="contained" onClick={handleContinue}>
          Продолжить
        </Button>
      </Box>
    </Box>
  )
}
